import { useState, useEffect } from "react";
import { getMe, extractTokenFromHash, type AuthUser } from "../lib/auth";

export function useAuth() {
  const [user, setUser] = useState<AuthUser | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Check for token in URL hash (OAuth callback)
    extractTokenFromHash();

    getMe().then((u) => {
      setUser(u);
      setLoading(false);
    });
  }, []);

  return { user, loading };
}
